import { float } from '@babylonjs/core'
import { Vertex3D } from './Construction'

export enum BuildingStructuralTypes {
  ShearWall = 'Shear Wall',
  LoadBearingWall = 'Load Bearing Wall',
  Beam = 'Beam',
  Stud = 'Stud',
  Header = 'Header',
  Joist = 'Joist',
  Roof = 'Roof',
  Foundation = 'Foundation',
}

export const StructuralBackgroundColor: Record<
  BuildingStructuralTypes,
  string
> = {
  [BuildingStructuralTypes.LoadBearingWall]: '#DEEDFF',
  [BuildingStructuralTypes.ShearWall]: '#F1F7FF',
  [BuildingStructuralTypes.Beam]: '#E9FEE7',
  [BuildingStructuralTypes.Stud]: '#F9E9F4',
  [BuildingStructuralTypes.Header]: '#E9FEE7',
  [BuildingStructuralTypes.Joist]: '#E9FEE7',
  [BuildingStructuralTypes.Roof]: '#F9E9F4',
  [BuildingStructuralTypes.Foundation]: '#95BAED',
}

export interface ShearWall {
  id: string
  wall_id: string
  angle: number
  center_point: number[]
  length: number
  height: number
  thickness: number
  stiffness_plf: number
}

export interface LoadBearingWall {
  id: string
  wall_id: string
  angle: number
  center_point: number[]
  length: number
  height: number
  thickness: number
  stiffness_plf: number
}

export enum RectangleFramingElementType {
  Beam = 'Beam',
  Joist = 'Joist',
  Stud = 'Stud',
  Header = 'Header',
  TopCripple = 'TopCripple',
  BotCripple = 'BotCripple',
  TopPlate = 'TopPlate',
  Sill = 'Sill',
  BotPlate = 'BotPlate',
  Rafter = 'Rafter',
  Ridge = 'Ridge',
  Hip = 'Hip',
  Post = 'Post',
}

export interface RectangleFramingElement {
  id: string
  center_point: Vertex3D
  thickness: number
  width: number
  length: number
  rotation_x: number
  rotation_y: number
  rotation_z: number
}

type PostZReference =
  | RectangleFramingElementType.Ridge
  | RectangleFramingElementType.Ridge
  | RectangleFramingElementType.Header
export interface Post extends RectangleFramingElement {
  z_reference?: PostZReference
}

export interface Beam extends RectangleFramingElement {
  posts?: Post[]
}

export interface Header extends RectangleFramingElement {
  posts?: Post[]
}

export interface Ridge extends RectangleFramingElement {
  posts?: Post[]
}

export interface PileCap {
  id: string
  top_center_point: Vertex3D
  length_x: number
  length_y: number
  length_z: number
  piles: Pile[]
}

export interface Pile {
  id: string
  top_center_point: Vertex3D
  length: number
  diameter: number
}

export interface StructuralSettings {
  category: string
  category_id: string
  variable: string
  value: float
  unit: string
  id?: number // Optional ID for the setting
  file_id?: number // Optional file ID for the setting
}
